




















































































































































































































































































































































































































import getVSelectOptionByValue from 'piramis-js-utils/lib/getVSelectOptionByValue'
import { Component, Emit, Mixins, Prop, Ref, Watch } from 'vue-property-decorator'

import AListCustom from '../../../../components/AListCustom/AListCustom.vue'
import AListCustomItem from '../../../../components/AListCustom/AListCustomItem.vue'
import SetUserEmail from "../../../../components/Auth/SetUserEmail.vue";
import SetUserPassword from "../../../../components/Auth/SetUserPassword.vue";
import AvatarsRow from "../../../../components/AvatarsRow.vue";
import { SelectOptionData } from "../../../../components/Pi/types";
import RecurringTargets from "../../../../components/RecurringTargets.vue";
import ZoomableImage from '../../../../components/ZoomableImage/ZoomableImage.vue'
import { checkLogin } from "../../../../logic/auth/logic";
import ClipboardCopyMixin from '../../../../logic/helpers/ClipboardCopyMixin'
import { SelectOption } from '../../../../logic/types'
import { FullBonusHistory, RefBonusHistory } from '../../includes/types/BonusHistory'
import { BonusInfo } from '../../includes/types/BonusInfo'
import { InvoiceInfo, InvoiceInfoWithTargets } from "../../includes/types/Shared/InvoiceInfo.types";
import InvoiceCard from './components/UserOperation/components/Invoice/InvoiceCard.vue'
import RecurringCard from "./components/UserOperation/components/Recurring/RecurringCard.vue";
import ReferralCard from './components/UserOperation/components/Referral/ReferralCard.vue'

enum Billing {
  Referral, // списание с бонусного счета
  Invoice, // поступление на бонусный счет
  RecurringInvoice, // активные подписки
}

@Component({
  components: {
    SetUserEmail,
    SetUserPassword,
    RecurringCard,
    RecurringTargets,
    AvatarsRow,
    AListCustomItem,
    AListCustom,
    ZoomableImage,
    InvoiceCard,
    ReferralCard,
  },
  data() {
    return {
      Billing
    }
  }
})
export default class UserProfile extends Mixins<ClipboardCopyMixin>(ClipboardCopyMixin) {
  @Prop() readonly bonusInfo!: BonusInfo

  @Prop() readonly invoices!: FullBonusHistory

  @Prop() readonly referralsInvoices!: RefBonusHistory

  @Prop() recurringInvoices!: Array<InvoiceInfo & { targets: Array<SelectOptionData> }>

  @Prop() availableUserLanguagesCode!: Array<string> // ['en', 'ru']

  @Ref('loadMoreUserOperationButton') readonly loadMoreUserOperationButton!: any

  @Emit()
  deleteRecurringInvoice(invoice: InvoiceInfoWithTargets) {
    return invoice
  }

  currentPage = 1

  activeTab: Billing = Billing.Invoice

  isSetPasswordModalOpen = false

  isSetEmailModalOpen = false

  @Watch('activeTab')
  onTabChange(): void {
    this.currentPage = 1
  }

  readonly languageNames: Record<string, string> = {
    en: 'English',
    ru: 'Русский',
  }

  readonly countryNames: Record<string, string> = {
    en: 'us',
    ru: 'ru',
  }

  get sortedInvoices(): FullBonusHistory {
    return this.invoices
      .sort((a, b) => Date.parse(b.invoice_date_time) - Date.parse(a.invoice_date_time))
  }

  get sortedReferralsInvoices(): RefBonusHistory {
    return this.referralsInvoices
      .sort((a, b) => (Date.parse(b.invoice?.invoice_date_time) || 0) - (Date.parse(a.invoice?.invoice_date_time) || 0))
  }

  get userLangOrBrowser() {
    return this.$store.getters["AdminTemplate/userLangOrBrowser"]
  }

  get user() {
    return this.$store.state.AdminTemplate?.user
  }

  get hasPassword() {
    if (typeof this.user?.has_password === 'boolean') {
      return this.user.has_password
    }

    return false
  }

  get email() {
    return this.user?.info?.Email
  }

  get hasEmail() {
    return !!(this.email && this.email.length);
  }

  get hasExtraAuth() {
    return this.$store.getters["AdminTemplate/hasExtraAuth"]
  }

  get userLang(): SelectOption | null {
    if (this.userLangOrBrowser) {
      return getVSelectOptionByValue(this.languagesOptions, this.$store.getters["AdminTemplate/userLangOrBrowser"])
    }

    return null
  }

  get languagesOptions(): Array<SelectOption> {
    return this.availableUserLanguagesCode.map((langCode: string) => ({
      label: this.languageNames[langCode],
      value: langCode,
    }))
  }

  get nextBonusLvlInfo(): string {
    const { bonus_bill } = this.bonusInfo

    if (bonus_bill) {
      const prettyNextDiscountValue = String(bonus_bill.next_discount_value + bonus_bill.currency.symbol)
      return this.$t('user_profile_bonus_info_text', [ bonus_bill.next_discount, prettyNextDiscountValue ]) as string
    }

    return ''
  }

  get recurringInvoicesApi() {
    return this.$store.state.AdminTemplate?.applicationConfig?.profile?.recurringInvoices
  }

  getCountryFlagSrc(languageCode: string): string {
    return `https://cdn.ip2location.com/assets/img/flags/${ this.countryNames[languageCode] }.png`
  }

  copyToClipBoard(text: string): void {
    this.copy(text)
  }

  updateUser() {
    checkLogin(this.$store)
  }

  mounted() {
    if (this.recurringInvoices?.length > 0) {
      this.activeTab = Billing.RecurringInvoice
    }
  }
}
